import type { ConfigRequestBody, ConfigResponse } from "../types/chat.types";

export async function ConfigRequestService(
  body: ConfigRequestBody,
): Promise<ConfigResponse> {
  const apiUrl = import.meta.env.VITE_API_URL;
  const headers: Record<string, string> = {
    "Content-Type": "application/json",
  };

  if (body.accessToken) {
    headers["Authorization"] = `Bearer ${body.accessToken}`;
  }
  const fullUrl = `${apiUrl}/config`;
  const response = await fetch(fullUrl, {
    method: "POST",
    headers,
    credentials: "include",
    body: JSON.stringify(body),
  });
  if (!response.ok) {
    const errorText = await response.text();
    throw new Error(
      `API error: ${response.status}: ${response.statusText}\n${errorText}`,
    );
  }
  return response.json();
}
